import { useCallback, useEffect } from "react";

import { useView, views } from "features/cdm/hooks/useView";

// CDM view state, persisted per patient, plus the helpers to move between the
// overview and a review preview. On entering the page (or switching patient)
// always land on the overview rather than re-opening a persisted review preview.
export const useCdmView = (patientId) => {
  const [view, setView] = useView(`kinesin-cdm-view-${patientId}`);

  useEffect(() => {
    if (view.name === views.general) {
      setView({ name: views.noChronicDiseases, cdmId: null });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [patientId]);

  const openReviewPreview = useCallback(
    (reviewId, { startEditing = false } = {}) =>
      setView({ name: views.general, cdmId: reviewId, startEditing }),
    [setView]
  );
  const closeReviewPreview = useCallback(
    () => setView({ name: views.noChronicDiseases, cdmId: null }),
    [setView]
  );

  return { view, setView, openReviewPreview, closeReviewPreview };
};
